import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TermsAndConditionsComponent } from './terms-and-conditions.component';
import { TermsAndConditionsRoutingModule } from "./terms-and-conditions-routing.module";
import { TranslatePipe } from "@ngx-translate/core";



@NgModule({
  declarations: [
    TermsAndConditionsComponent
  ],
    imports: [
        CommonModule,
        TermsAndConditionsRoutingModule,
        TranslatePipe
    ]
})
export class TermsAndConditionsModule { }
